import { TextField } from "@atlas/ui/web";
import { readOnlyInputStyle } from "../lib/edicao-manual";

/**
 * Situacao do acesso do master, nos modais de organizacao e de banco.
 *
 * Ocupa o lugar do antigo campo de senha. Desde 09/10/2026 a averbadora nao
 * cadastra mais a senha do master: ele ativa a conta em /primeiro-acesso com o
 * e-mail de login, e o codigo de confirmacao chega nesse e-mail. O que a
 * averbadora precisa ver aqui e' so' se isso ja aconteceu.
 *
 * `loginTrocado`: o e-mail de login digitado difere do salvo. A API descarta a
 * senha nesse caso (ela foi criada por quem provou posse do e-mail antigo), e
 * quem edita precisa saber disso ANTES de salvar.
 */
export function AcessoMaster({ hasPassword, loginTrocado = false }: { hasPassword: boolean; loginTrocado?: boolean }) {
  const ativado = hasPassword && !loginTrocado;
  return (
    <TextField
      label="Acesso do master"
      value={ativado ? "✓ ativado" : "Aguardando primeiro acesso"}
      readOnly
      onChange={() => undefined}
      style={{
        ...readOnlyInputStyle,
        color: ativado ? "var(--emerald-500)" : "var(--gold-500)",
      }}
      hint={
        hasPassword && loginTrocado
          ? "Trocar o e-mail de login descarta a senha atual: o master refaz o primeiro acesso com o e-mail novo."
          : ativado
            ? "O master criou a senha no primeiro acesso. Se esquecer, usa “Esqueci minha senha”."
            : "Não há senha a cadastrar: o master entra em “Primeiro acesso” com o e-mail de login e confirma pelo código enviado a ele."
      }
    />
  );
}
